// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"map-marker-module--wrapper--3d8Aj","icon":"map-marker-module--icon--r8Id9"};